import React, { useEffect } from 'react'
import { onClientSide } from 'utils/utils'
import useModal from '@/modern/actions/useModal'
import ModalContainer from '@/modern/components/ModalContainer'
import * as S from '../style'

function SuccessModal({ email }) {
  const { closeModal, modal } = useModal('promoBlackFairSuccessModal')

  function handleCloseModal(event) {
    if (!onClientSide()) return
    if (event) {
      event.stopPropagation()
    }
    closeModal()
  }

  useEffect(() => {
    if (onClientSide()) {
      if (modal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
      return () => {
        document.body.style.overflow = ''
      }
    }
  }, [modal])

  return (
    <ModalContainer
      align="center"
      show={modal}
      useWhiteBox
      onBgClick={e => handleCloseModal(e)}
    >
      <S.Wrapper>
        <S.CloseButton onClick={e => handleCloseModal(e)}>
          <S.CloseIcon name="Close_1" fill="#2E2E37" size="24" />
        </S.CloseButton>
        <S.ImageContainer>
          <img
            src="/assets/img/webp/Icone-success.webp"
            alt="Promo Black feirão 2024"
          />
        </S.ImageContainer>
        <S.HeadingSuccess>
          Quase lá!
          <br /> Enviaremos um e-mail para:
        </S.HeadingSuccess>
        <S.HeadingEmail>{email}</S.HeadingEmail>
        <S.InfoSuccess>
          Siga as instruções para garantir
          <br />
          sua participação e concorrer a prêmios.
        </S.InfoSuccess>
      </S.Wrapper>
    </ModalContainer>
  )
}

export default SuccessModal
